import { render } from "./penddingPoints.vue?vue&type=template&id=bbbf6dac&scoped=true"
import script from "./penddingPoints.vue?vue&type=script&lang=js"
export * from "./penddingPoints.vue?vue&type=script&lang=js"

import "./penddingPoints.vue?vue&type=style&index=0&id=bbbf6dac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbbf6dac"]])

export default __exports__